import React from 'react';

export default function Logo({ size = 'nav', className = '' }) {
  const sizeMap = {
    nav: { diamond: 18, fontSize: '18px', gap: '8px' },
    hero: { diamond: 36, fontSize: '36px', gap: '14px' },
    small: { diamond: 12, fontSize: '13px', gap: '5px' },
  };
  const s = sizeMap[size] || sizeMap.nav;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: s.gap,
        textDecoration: 'none',
      }}
      className={className}
      aria-label="reAImagination"
    >
      {/* Diamond mark */}
      <svg width={s.diamond} height={s.diamond} viewBox="0 0 20 20">
        <polygon points="10,1 19,10 10,19 1,10" fill="none" stroke="#00D4C8" strokeWidth="1.5" />
        <polygon points="10,5 15,10 10,15 5,10" fill="#00D4C8" fillOpacity="0.25" stroke="#00D4C8" strokeWidth="0.8" />
      </svg>
      {/* Wordmark as HTML - preserves case */}
      <span
        style={{
          fontFamily: "'Syne', sans-serif",
          fontSize: s.fontSize,
          fontWeight: 700,
          letterSpacing: '0.04em',
          lineHeight: 1,
          userSelect: 'none',
        }}
      >
        <span style={{ color: '#F2F6FA' }}>re</span>
        <span style={{ color: '#00D4C8' }}>AI</span>
        <span style={{ color: '#F2F6FA' }}>magination</span>
      </span>
    </div>
  );
}
